// src/utils/bankAccountService.js
import http from "../api/apiClient";

/**
 * Approve a bank account as admin
 * @param {string} bankAccountId
 * @param {string} adminUuid  // verplicht volgens backend
 */
export const approveBankAccount = async (bankAccountId, /* token ignored */ _ , adminUuid) => {
  if (!adminUuid) {
    throw new Error("approveBankAccount: 'adminUuid' is vereist.");
  }
  try {
    await http.post(`/bank-accounts/${encodeURIComponent(bankAccountId)}/approve`, null, {
      params: { adminUuid },
    });
  } catch (err) {
    console.error("❌ Failed to approve bank account:", err);
    throw err;
  }
};

/**
 * Create a bank account for a parent
 * @param {{ parentUuid:string, iban:string, accountHolderName:string }} payload
 * @returns {Promise<any>}
 */
export const createBankAccount = async (payload /*, token ignored */) => {
  try {
    const { data } = await http.post(`/bank-accounts`, payload);
    return data;
  } catch (err) {
    console.error("❌ Failed to create bank account:", err);
    throw err;
  }
};

/**
 * Get the bank account of a specific parent
 * @param {string} parentId
 * @returns {Promise<object|null>} bank account or null if none found
 */
export const getBankAccount = async (parentId /*, token ignored */) => {
  try {
    // ✅ juiste endpoint volgens controller: /by-parent/{parentUuid}
    const { data } = await http.get(`/bank-accounts/by-parent/${encodeURIComponent(parentId)}`);
    return data || null;
  } catch (err) {
    if (err?.response?.status === 404) return null; // geen account
    console.error("❌ Failed to fetch bank account:", err);
    throw err;
  }
};